import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { CMSStorageService } from 'app/core/service/CMS-Storage.service';
import { EmployeeServiceService } from 'app/core/service/employee-service.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    styleUrls: ['./classy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FuseLoadingBarComponent,
        FuseVerticalNavigationComponent,
        NotificationsComponent,
        UserComponent,
        MatIconModule,
        MatButtonModule,
        RouterOutlet,
    ],
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    userName: string;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    mailId: any;
    profileImange: any;
    imagePreview: string;
    getpersonaldetails: any;
    imageUrl: string;
    getemployeeOfficialDetails: any;
    designation: any;
    employeeCode: any;
    role: string;
    showEmpCode: boolean;
    oneCoherentIsTrue: any;
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private employeeService: EmployeeServiceService,
        private cmsStorageService: CMSStorageService,
    ) {
        const encryptedData = localStorage.getItem('oneCoherentIsTrue');
        this.cmsStorageService.setItem('oneCoherentIsTrue', encryptedData);
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        this.cmsStorageService.getItem().subscribe((data) => {
            this.userName = data.Name;
            this.mailId = data.Mail;
            this.role = data.Role;
            this.oneCoherentIsTrue = data?.oneCoherentIsTrue;
            if (this.oneCoherentIsTrue == true) {
                const navigation =
                    this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                        'mainNavigation',
                    );
                if (navigation) {
                    navigation.close();
                }
            }
        });

        if (
            this.role == 'Financial Manager' ||
            this.role == 'Accounting Manager' ||
            this.role == 'PM' ||
            this.role == 'IT Team'
        ) {
            this.showEmpCode = false;
        } else {
            this.showEmpCode = true;
            this.OfficialDetails();
            this.getPersonalDetails();
        }
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });
        // Subscribe to the user service
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small (collapse sidebar on 'sm' and smaller screens, keep open on 'md' and above)
                this.isScreenSmall = !matchingAliases.includes('lg');
            });
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name,
            );
        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
    OfficialDetails() {
        this.employeeService
            .employeeOfficialDetailsView()
            .subscribe((data: any) => {
                this.getemployeeOfficialDetails = data;
                this.designation =
                    this.getemployeeOfficialDetails.data[0].designation;
                this.employeeCode =
                    this.getemployeeOfficialDetails.data[0].employeeCode;
                this.cmsStorageService.setItem(
                    'Employee Code',
                    this.employeeCode,
                );
            });
    }
    getPersonalDetails() {
        this.employeeService
            .employeePersonalDetailsView()
            .subscribe((data: any) => {
                this.getpersonaldetails = data;
                this.imageUrl = this.getpersonaldetails.data
                    .employeePersonalDetailsViewDTOList[0].imageDTO
                    ? 'data:' +
                      this.getpersonaldetails.data
                          .employeePersonalDetailsViewDTOList[0].imageDTO
                          .imageType +
                      ';base64,' +
                      this.getpersonaldetails.data
                          .employeePersonalDetailsViewDTOList[0].imageDTO.image
                    : null;
                this.userName =
                    this.getpersonaldetails.data
                        .employeePersonalDetailsViewDTOList[0].firstName +
                    ' ' +
                    this.getpersonaldetails.data
                        .employeePersonalDetailsViewDTOList[0].lastName;
            });
    }
}
